import * as NewsActions from '../actions/NewsActions';
import iconSearch from '../img/icon-search.png';
import iconXBlack from '../img/icon-x-black.png';
import ListFilter from './ListFilter';
import NewsItem from './NewsItem';
import Pagination from './Pagination';
import PropTypes from 'prop-types';
import QueryString from 'query-string';
import React from 'react';
import SearchClearOrBusy, {SEARCH_BUSY_MIN_MS} from './SearchClearOrBusy';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';
import {getDefaultNewsFilterState, getFilteredNews} from '../utils/newsListFilters';


const EVENTS_PER_PAGE = 10;


class News extends React.Component{
  state = {
    currentPage: 1,
    value: '',
    inputValue: '',
    selectedProgram: [],
    selectedCategory: [],
    startDate: null,
    endDate: null,
    modalOpen: false,
    searchBusy: false,
  };


  constructor(props){
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClearInput = this.handleClearInput.bind(this);
  }
  componentDidMount(){
    const query = QueryString.parse(this.props.location.search);
    this.props.actions.initNews().then(payload => {
      this.setState(getDefaultNewsFilterState({
        programs: payload?.programs || [],
        programFromUrl: query?.program,
      }));
    });
  }
  componentWillUnmount(){
    window.clearTimeout(this._searchBusyTimer);
  }
  getAllProgramIds = () => (this.props.News.programs || []).map(item => item.id);
  getFilteredNewsList = () => {
    const {
      value,
      selectedCategory,
      selectedProgram,
      startDate,
      endDate,
    } = this.state;
    const {News} = this.props;

    return getFilteredNews(
      News.news,
      value,
      selectedCategory,
      selectedProgram,
      startDate,
      endDate,
      this.getAllProgramIds(),
    );
  };


  handleCategoryFilter = (value, type) => {
    if(type === 'category'){
      const {selectedCategory} = this.state;
      const next = selectedCategory.includes(value)
        ? selectedCategory.filter(id => id !== value)
        : [...selectedCategory, value];
      this.setState({selectedCategory: next});
    }
    else if(type === 'program'){
      const {selectedProgram} = this.state;
      const next = selectedProgram.includes(value)
        ? selectedProgram.filter(id => id !== value)
        : [...selectedProgram, value];
      this.setState({selectedProgram: next});
    }
  };
  handleClearFilter = () => {
    this.setState({
      ...getDefaultNewsFilterState({
        programs: this.props.News.programs || [],
      }),
      currentPage: 1,
    });
  };
  handleClearInput = () => {
    window.clearTimeout(this._searchBusyTimer);
    this.setState({
      value: '',
      inputValue: '',
      currentPage: 1,
      searchBusy: false,
    });
  };
  handleEndDate = endDate => {
    this.setState({
      endDate,
    });
  };
  handleInputChange = evt => {
    this.setState({
      inputValue: evt.target.value,
    });
  };
  handleSearchSubmit = evt => {
    evt.preventDefault();
    this.setState({
      value: this.state.inputValue,
      currentPage: 1,
      searchBusy: true,
    });
    window.clearTimeout(this._searchBusyTimer);
    this._searchBusyTimer = window.setTimeout(() => {
      this.setState({searchBusy: false});
    }, SEARCH_BUSY_MIN_MS);
  };
  handleModalShow = () => {
    this.setState({
      modalOpen: true,
    });
  };
  handleModalHide = () => {
    this.setState({
      modalOpen: false,
    });
  };
  handlePagination = page => {
    this.setState({
      currentPage: page,
    });
  };
  handleStartDate = startDate => {
    this.setState({
      startDate,
    });
  };


  renderEvents = () => {
    const {currentPage} = this.state;
    const {News} = this.props;

    if(!News.news) return null;
    const newNews = this.getFilteredNewsList();

    return newNews
      .slice((currentPage - 1) * EVENTS_PER_PAGE, EVENTS_PER_PAGE * currentPage)
      .map(event => {
        return (
          <div key={event.id} className="col-12 news__listing-item-col">
            <NewsItem event={event}
                      className="news__news-item"
                      disableLocation/>
          </div>
        );
      });
  };
  renderResultStatus = () => {
    const {News} = this.props;
    const {currentPage} = this.state;

    if(!News.news) return null;
    const newNews = this.getFilteredNewsList();
    const startFrom = (currentPage - 1) * EVENTS_PER_PAGE + 1;
    const lastTo =
      currentPage * EVENTS_PER_PAGE > newNews.length
      ? newNews.length
      : currentPage * EVENTS_PER_PAGE;

    if(newNews.length === 0) return null;

    return (
      <div className="news__results">
        {`Showing ${startFrom}-${lastTo} of ${newNews.length}`}
      </div>
    );
  };
  renderFilterButton = () => (
    <button type="button"
            className="news__filter-button"
            aria-label="Filter News"
            onClick={this.handleModalShow}>
      Filter
    </button>
  );
  render(){
    //console.log(`MEvents render`, this.props);
    if((!this.props.News || !this.props.News.news)) return null;

    const {
      value,
      inputValue,
      selectedCategory,
      selectedProgram,
      startDate,
      endDate,
      modalOpen,
      searchBusy,
    } = this.state;
    const {News} = this.props;
    const totalPage =
      News && News.news && News.news.length > 0
      ? Math.ceil(
        this.getFilteredNewsList().length / EVENTS_PER_PAGE,
      )
      : 0;

    const isOpen = Boolean(inputValue);
    //console.log('---mevents', News);

    return this.props.News ? (
      <div className="columns">
        <div className="coupling coupling--parent coupling--left">
          <div className={`news ${this.props.className || ''}`}>
            <div className="container container--coupling">
              <div className="news__search-row">
                <form className={`button-input ${isOpen ? 'search-input-open' : ''}`}
                      role="search"
                      onSubmit={this.handleSearchSubmit}>
                  <button aria-label="Search"
                          className="button-input__button"
                          type="submit">
                    <img alt="" className="button-input__button-icon" src={iconSearch}/>
                  </button>

                  <input aria-label="Search Input"
                         className={`button-input__input input ${isOpen ? 'search-input-open' : ''}`}
                         type="text"
                         name="query"
                         value={inputValue}
                         placeholder="Search news and updates by phrase or keyword"
                         aria-busy={searchBusy ? true : undefined}
                         onChange={this.handleInputChange}/>

                  {(isOpen || searchBusy) && <SearchClearOrBusy isLoading={searchBusy}
                                                               iconSrc={iconXBlack}
                                                               onClear={this.handleClearInput}/>}
                </form>
                {this.renderFilterButton()}
              </div>
              {this.renderResultStatus()}
              {totalPage === 0 && (
                <div className="no-search-results">
                  <div>
                    {`Sorry this search doesn't have any results.`}
                  </div>
                  <div className="no-results-suggestion">
                    Search Suggestions
                    <ul>
                      <li>Check spelling</li>
                      <li>Try more general words</li>
                      <li>Remove some search filters</li>
                      <li>
                        <a href="/get-involved" target="_blank">Contact us</a> {`if you still can't find what you are looking for`}
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              <div className="news__listing">
                <div className="row">{this.renderEvents()}</div>
              </div>
              <Pagination totalPage={totalPage}
                          currentPage={this.state.currentPage}
                          handlePagination={this.handlePagination}/>
            </div>
          </div>
        </div>
        <div className="coupling coupling--parent coupling--right">
          <ListFilter programs={News.programs || []}
                      selectedProgram={selectedProgram}
                      title="Filter News"
                      handleCategoryFilter={this.handleCategoryFilter}
                      handleStartDate={this.handleStartDate}
                      handleEndDate={this.handleEndDate}
                      handleClearFilter={this.handleClearFilter}
                      modalOpen={modalOpen}
                      handleModalHide={this.handleModalHide}/>
        </div>
      </div>
    ) : null;
  }
}


export default withRouter(connect(
  state => ({
    News: state.news,
  }),
  dispatch => ({
    actions: bindActionCreators(NewsActions, dispatch),
  }),
)(News));


News.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  location: PropTypes.object,
  News: PropTypes.object,
};
